/**
 * Helper function to export data to a file.
 * @param data - The content to be exported. Can be a string or a Blob.
 * @param fileName - The name of the file to be downloaded.
 * @param fileType - The MIME type of the file. Defaults to 'text/plain'.
 */
export const exportToFile = (data: string | Blob, fileName: string, fileType: string = 'text/plain'): void => {
    try {
        // Create a Blob from the data
        const blob = typeof data === 'string' ? new Blob([data], { type: fileType }) : data;

        // Create a temporary URL for the Blob
        const url = URL.createObjectURL(blob);

        // Create a temporary anchor element to trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // Set the file name
        document.body.appendChild(a); // Append the anchor to the body
        a.click(); // Trigger the download
        document.body.removeChild(a); // Remove the anchor from the body

        // Revoke the temporary URL to free up resources
        URL.revokeObjectURL(url);

        console.log(`File "${fileName}" exported successfully.`);
    } catch (error) {
        console.error('Error exporting file:', error);
    }
};